import { ResourceOptions } from 'react-admin';
import { FaLayerGroup } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxLevelSystem;
export const icon = FaLayerGroup;
export const options: ResourceOptions = {
  label: 'module.blindBox.levelSystem',
};
